export const buildClassName = (...parts: (string | false | undefined)[]) => {
  return parts.filter(Boolean).join(' ');
};

export default buildClassName;
